module.exports = __webpack_public_path__ + "img/43581d0.png";